import type { IconProps } from './types';

export const Plus = ({ size, ...props }: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M15 9.75012H9.75V15.0001H8.25V9.75012H3V8.25012H8.25V3.00012H9.75V8.25012H15V9.75012Z"
      fill="currentColor"
    />
  </svg>
);
